const getUserAgent = () =>
  typeof navigator === 'undefined'
    ? ''
    : (
        navigator.userAgent ||
        navigator.vendor ||
        (window as any).opera ||
        ''
      ).toLowerCase();

export const getDevice = () => {
  const userAgent = getUserAgent();

  if (/ipad|iphone|ipod/.test(userAgent)) {
    return 'ios';
  }

  if (/mac/.test(userAgent)) {
    return 'mac';
  }

  if (/windows phone/.test(userAgent)) {
    return 'windows phone';
  }

  if (/android/.test(userAgent)) {
    return 'android';
  }

  if (/win/.test(userAgent)) {
    return 'windows';
  }

  return 'desktop';
};

// TODO: Check for desktop, android, firefox, Opera etc...
export const getBrowser = () => {
  const userAgent = getUserAgent();

  const os = getDevice();

  if (os === 'ios') {
    if (/crios/.test(userAgent)) {
      return 'ios_chrome';
    }
    return 'ios_safari';
  }

  return 'unknown';
};
